import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Switch, Tooltip, message } from 'antd';
import { captureAnalytics } from '../../../actions/preload';

const SftpCategorySwitch = ({
  categoryId, selected, canEnable, isAdmin, save,
}) => {
  const [saving, setSaving] = useState(false);
  const toggle = async () => {
    if (saving) return;
    const enabled = !selected;
    setSaving(true);
    let outcome = 'failure';
    try {
      const result = await save(categoryId, enabled);
      if (result?.error) {
        message.error(result.response?.data?.error || result.response?.data?.message || 'Could not save SFTP routing');
      } else {
        outcome = 'success';
        message.success('SFTP routing saved');
      }
    } catch {
      message.error('Could not save SFTP routing');
    } finally {
      setSaving(false);
      captureAnalytics('category_sftp_only_changed', { enabled, outcome });
    }
  };

  return (
    <Tooltip title="Send this AI category to SFTP and skip automatic EMR uploads. Existing SFTP deliveries continue after clearing.">
      <Switch
        aria-label="SFTP only"
        checked={selected}
        loading={saving}
        disabled={saving || !isAdmin || (!selected && !canEnable)}
        onClick={toggle}
      />
    </Tooltip>
  );
};

SftpCategorySwitch.propTypes = {
  categoryId: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
  canEnable: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
};

export default SftpCategorySwitch;
